module.exports = __webpack_public_path__ + "static/media/25.f0499f8e.png";